import {NgModule} from "@angular/core";
import {TabStripComponent} from "./tab.strip.component/tab.strip.component";
import {TabStripItemTemplateDirective} from "./tab.strip.component/tab.strip.item.template.directive";
import {CommonModule} from "@angular/common";
import {CPTranslateModule} from "../../../translate";

@NgModule({
	declarations: [TabStripComponent, TabStripItemTemplateDirective],
	exports: [TabStripComponent, TabStripItemTemplateDirective],
	imports: [CommonModule, CPTranslateModule]
})
export class TabStripModule {}
